import RestService from './RestService'

export default class ImageService extends RestService {
    constructor() {
        super('images')
    }

    siteImages(websiteId) {
        let url = this.baseUrl + `/api/v1/images.json?site_id=${websiteId}&t=${Date.now()}`
        return this.executeGet(url)
    }

    uploadImage(imageableType, imageableId, file) {
        let url = this.baseUrl + '/api/v1/images.json?t=' + Date.now()

        let formData = new FormData()
        formData.append('image[name]', file.name)
        formData.append('image[source]', 'Upload')
        formData.append('image[paperclip_image]', file)
        formData.append('image[imageable_type]', imageableType)
        formData.append('image[imageable_id]', imageableId)

        return new Promise((resolve, reject) => {
            this.http.post(url)
                .send(formData)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        let updatedRecord = JSON.parse(response.text)
                        console.log('Image saved')
                        console.log(updatedRecord)
                        resolve(updatedRecord)
                    } else {
                        // this.messageUtil.error(response.statusText)
                        reject(response.statusText)
                    }

                })
        })
    }
}